<template>
    <el-popover placement="bottom-end" width="300" trigger="click" class="userinfo-pop">
        <el-form label-width="60px" :model="formData" ref="userForm" size="mini">
            <el-form-item label="用户id" prop="userId">
                <el-input v-model="formData.userId"></el-input>
            </el-form-item>
            <el-form-item label="加密id" prop="aesId">
                <el-input v-model="formData.aesId"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phoneNumber">
                <el-input v-model="formData.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
                <el-input v-model="formData.nickname"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="baseInfo">确定</el-button>
                <el-button size="mini" @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-button slot="reference" type="info" icon="el-icon-search" circle></el-button>
    </el-popover>
</template>
<script>
import api from '../../views/api'
let {
    user
} = api
export default {
    name: 'userInfo',
    data() {
        return {
            formData: {
                userId: '',
                aesId: '',
                phoneNumber: '',
                nickname: '',
            }
        }
    },
    watch: {},
    mounted() {},
    methods: {
        async baseInfo() {
            let res = await user.baseInfo(this.formData)
            this.formData = res.data.data[0]
        },
        resetForm() {
            this.$refs['userForm'].resetFields()
        },
    },
}
</script>
<style>
.userinfo-pop {
    position: fixed;
    top: 60px;
    right: 20px;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/common/userInfo.vue